import React from 'react';
import block from 'propmods';
import { Button, Icon } from 'lego-on-react';

import './MonitoringPageHistoryControls.scss';

const b = block('MonitoringPageHistoryControls');

interface Props {
    goPrevRange: () => void;
    goNextRange: () => void;
    initRanges: () => void;
    hasPrevRange?: boolean;
    hasNextRange?: boolean;
}

export const MonitoringPageHistoryControls: React.FC<Props> = ({
    goPrevRange,
    goNextRange,
    initRanges,
    hasPrevRange,
    hasNextRange,
}) => {
    return (
        <div {...b('')}>
            <span {...b('button')}>
                <Button size="s" theme="normal" onClick={() => goPrevRange()} disabled={!hasPrevRange}>
                    <Icon type="arrow" direction="left" />
                </Button>
            </span>
            <span {...b('button')}>
                <Button size="s" theme="normal" onClick={() => goNextRange()} disabled={!hasNextRange}>
                    <Icon type="arrow" direction="right" />
                </Button>
            </span>
            <span {...b('button')}>
                <Button size="s" theme="normal" onClick={() => initRanges()}>
                    Сбросить приближение
                </Button>
            </span>
        </div>
    );
};
